import axios from 'axios';

const publicBillingAxios = axios.create({ baseURL: process.env.REACT_APP_BILLING_BASE_URL });

// eslint-disable-next-line consistent-return
export default async function getMSA(params) {
  const { data } = await publicBillingAxios.post('selfserve/regular-msa', params, { responseType: 'blob' });

  if (data) return URL.createObjectURL(data);
}
